import React, { useState, useEffect, useRef, memo } from "react";
import { Table as AntdTable, Button, Input, Space, Tooltip } from 'antd';
import { Footer } from '../../PageLayout/Footer';
import { Layout } from '../../PageLayout/Layout';
import api from '../../../Service/Api';
import backend from '../../../Service/Backend';
import './index.css';
import ProgressLoader from "../../Common/ProgressLoader";
import { SearchOutlined,  ReloadOutlined} from '@ant-design/icons';
import type { InputRef } from 'antd';
import type { ColumnType } from 'antd/es/table';
import type { FilterConfirmProps } from 'antd/es/table/interface';
import Highlighter from 'react-highlight-words';
import { firstBy } from 'thenby';
import Algolia from "../../Algolia/Algolia";
import useCheckMobileScreen, { useCheckTabScreen } from "../../../hooks/useCheckMobileScreen";
import TableComponent from "../../TableComponent";

const { REACT_APP_ALGOLIA_API_RESPONSE_LIST_INDEX_NAME } = process.env;
const APIIntegrationsHOC = (props: any) => {
    const role = sessionStorage.getItem('role')
    const [dataList, setDataList] = useState([]);
    const [algoliaLoading, setAlgoliaLoading] = useState(true);

    const [config, setConfig] = useState({
        algoliaIndex: REACT_APP_ALGOLIA_API_RESPONSE_LIST_INDEX_NAME, // Algolia Index Mandatory
        hitsPerPage: 10000, // No of records per page
        filters: '', // Algolia Filters
        setDataList: setDataList, // Temp set list of hits value
        dataList: dataList, // Algolia list of hits value,
        refresh: true,
        algoliaLoading: algoliaLoading,
        setAlgoliaLoading: setAlgoliaLoading,
    });
    const APIIntegrations = (props: any) => {
        const [loading, setLoading] = useState(true)
        const [data, setData] = useState([] as any)
        const [searchText, setSearchText] = useState('');
        const [searchedColumn, setSearchedColumn] = useState('');
        const searchInput = useRef<InputRef>(null);
        const [overlay, setOverlay] = useState({ style: { display: 'none' } })
        const [overlayMsg, setOverlaymsg] = useState('')

        const formatDate = (date: any) => {
            var d = new Date(date)
            var month = '' + (d.getMonth() + 1)
            var day = '' + d.getDate()
            var year = d.getFullYear()

            if (month.length < 2) month = '0' + month
            if (day.length < 2) day = '0' + day

            return [month, day, year].join('-')
        }

        const sleep = (milliseconds: number) => {
            return new Promise((resolve) => setTimeout(resolve, milliseconds))
        }

        const showOverlayForThreeSeconds = async () => {
            const sstyle: any = { style: { display: 'block', position: 'fixed' } }
            setOverlay(sstyle)
            await sleep(1000)
            const hstyle: any = { style: { display: 'none' } }
            setOverlay(hstyle)
        }


        const fetchIntegrationData = async () => {

            try {
                console.log('response', dataList)
                if (dataList) {
                    dataList.sort(
                        firstBy(
                            function (v: any) {
                                return new Date(
                                    v.created_ts?._seconds * 1000 +
                                    v.created_ts?._nanoseconds / 1000000
                                )
                            },
                            { direction: 'desc' }
                        )
                    )

                    const formatedData = dataList.filter((item: any) => (item.api_request_data.apiType === 'giact' || item.api_request_data.apiType === 'transunion' || item.api_request_data.apiType === 'createApptivo') && !!item.appID).map((item: any) => {
                        const createdTS = formatDate(new Date(item.created_ts._seconds * 1000 + item.created_ts._nanoseconds / 1000000).toDateString())
                        const updatedTS = formatDate(new Date(item.updated_ts._seconds * 1000 + item.updated_ts._nanoseconds / 1000000).toDateString())

                        return {
                            key: item.doc_id,
                            apiType: item.api_request_data.apiType,
                            apiroute: item.api_request_data.apiroute,
                            status: item.status || "",
                            appID: item.appID,
                            createdTS: createdTS,
                            updatedTS: updatedTS,
                            docID: item.doc_id,
                            retried: item.retried ? 'Retried' : '',
                        }
                    })



                    setData(formatedData)
                }
            } catch (error) {
                console.log(error)
            } finally {
                setLoading(false)
            }
        }

        useEffect(() => {
            setLoading(true)
            if (dataList && dataList.length > 0 && !algoliaLoading) fetchIntegrationData();
        }, [dataList, algoliaLoading])

        const handleSearch = (
            selectedKeys: string[],
            confirm: (param?: FilterConfirmProps) => void,
            dataIndex: any,
        ) => {
            confirm();
            setSearchText(selectedKeys[0]);
            setSearchedColumn(dataIndex);
        };

        const handleReset = (clearFilters: () => void,
            confirm: (param?: FilterConfirmProps) => void,
            dataIndex: any,) => {
            clearFilters();
            setSearchText('');
            confirm();
            setSearchedColumn(dataIndex);
        };

        const getColumnSearchProps = (dataIndex: any): ColumnType<any> => ({
            filterDropdown: ({ setSelectedKeys, selectedKeys, confirm, clearFilters, close }) => (
                <div style={{ padding: 8 }} onKeyDown={e => e.stopPropagation()}>
                    <Input
                        ref={searchInput}
                        placeholder={`Search ${dataIndex}`}
                        value={selectedKeys[0]}
                        onChange={e => setSelectedKeys(e.target.value ? [e.target.value] : [])}
                        onPressEnter={() => handleSearch(selectedKeys as string[], confirm, dataIndex)}
                        style={{ marginBottom: 8, display: 'block' }}
                    />
                    <Space>
                        <Button
                            type="primary"
                            onClick={() => handleSearch(selectedKeys as string[], confirm, dataIndex)}
                            icon={<SearchOutlined />}
                            size="small"
                            style={{ width: 90 }}
                        >
                            Search
                        </Button>
                        <Button
                            onClick={() => clearFilters && handleReset(clearFilters, confirm, dataIndex)}
                            size="small"
                            style={{ width: 90 }}
                        >
                            Reset
                        </Button>
                        {/* <Button
                        type="link"
                        size="small"
                        onClick={() => {
                            confirm({ closeDropdown: false });
                            setSearchText((selectedKeys as string[])[0]);
                            setSearchedColumn(dataIndex);
                        }}
                    >
                        Filter
                    </Button> */}
                        <Button
                            type="link"
                            size="small"
                            onClick={() => {
                                close();
                            }}
                        >
                            close
                        </Button>
                    </Space>
                </div>
            ),
            filterIcon: (filtered: boolean) => (
                <SearchOutlined style={{ color: filtered ? '#1890ff' : undefined }} />
            ),
            onFilter: (value, record) =>
                record[dataIndex]
                    .toString()
                    .toLowerCase()
                    .includes((value as string).toLowerCase()),
            onFilterDropdownOpenChange: visible => {
                if (visible) {
                    setTimeout(() => searchInput.current?.select(), 100);
                }
            },
            render: text =>
                searchedColumn === dataIndex ? (
                    <Highlighter
                        highlightStyle={{ backgroundColor: '#ffffff', padding: 0 }}
                        searchWords={[searchText]}
                        autoEscape
                        textToHighlight={text ? text.toString() : ''}
                    />
                ) : (
                    text
                ),
        });

        const retryIntegration = async (record: any) => {
            setLoading(true)
            try {
                const payload: any = {
                    payLoad: JSON.stringify({
                        merchantAppID: record.appID,
                        docID: record.docID
                    })
                }

                switch (record.apiroute) {
                    case 'verify_customer':
                        payload.api = api.integrations.validateCustomerDetails
                        break;
                    case "validate_bank_details":
                        payload.api = api.integrations.validateBankDetails
                        break;
                    case "credit-report-xml":
                        payload.api = api.integrations.getCreditReportXML
                        break;
                    case "credit-report-pdf":
                        payload.api = api.integrations.getCreditReportPDF
                        break;
                    case "create_apptivo":
                        payload.api = api.integrations.createApptivo
                        break;
                    default:
                        return;
                }
                if (!!payload.api) {
                    await backend.save(payload);
                    let updatedData = data?.map((item: any) => {
                        if (record.docID === item.docID) {
                            return { ...item, retried: 'Retried' }
                        } else {
                            return item
                        }
                    })
                    setData(updatedData)
                }
                setLoading(false)
            } catch (err: any) {
                console.log(err)
                showOverlayForThreeSeconds()
                setOverlaymsg(err.errMessage || 'Something went wrong. Please try again')
            } finally {
                setLoading(false)
            }

        }

        const columns: any = [
            {
                title: 'App ID',
                dataIndex: 'appID',
                key: 'appID',
                ...getColumnSearchProps('appID'),
            },
            {
                title: 'API Type',
                dataIndex: 'apiType',
                key: 'apiType',
                ...getColumnSearchProps('apiType'),
            },
            {
                title: 'API Route',
                dataIndex: 'apiroute',
                key: 'apiroute',
                ...getColumnSearchProps('apiroute'),
            },
            {
                title: 'Created Date',
                dataIndex: 'createdTS',
                key: 'createdTS',
                ...getColumnSearchProps('createdTS'),
            },
            {
                title: 'Updated Date',
                dataIndex: 'updatedTS',
                key: 'updatedTS',
                ...getColumnSearchProps('updatedTS'),
            },
            {
                title: 'Status',
                dataIndex: 'status',
                key: 'status',
                ...getColumnSearchProps('status'),
            },
            {
                title: 'Retry Status',
                dataIndex: 'retried',
                key: 'retried',
                ...getColumnSearchProps('retried'),
            },
            {
                title: "Actions",
                key: 'action',
                render: (record: any) => {
                    return (
                        <>
                            {record.status !== 'failed' || record.retried ? <></> :
                                <Button type="link" onClick={() => { retryIntegration(record) }}>
                                    Re-try
                                </Button>
                            }
                        </>
                    )
                }
            }
        ]

        const getTableKeys = (
            isMobile: boolean,
            isTablet: boolean,
            role: string | null
          ) => {
            let headerKeys: any = [];
            let rowKeys: any = [];
            if (isMobile) {
              headerKeys = [
                { label: "App ID", key: "appID" },
                { label: "API Type", key: "apiType" },
                { label: "Status", key: "status" },
              ];
          
              rowKeys = [
                { key: "apiroute", label: "API Route" },
                { key: "createdTS", label: "Created Date" },
                { key: "updatedTS", label: "Updated Date" },
                { key: "retried", label: "Retry Status" },
              ];
            } else if (isTablet) {
              if (window.innerWidth < window.innerHeight) {
                headerKeys = [
                  { label: "App ID", key: "appID" },
                  { label: "API Type", key: "apiType" },
                  { label: "Status", key: "status" },
                  { key: "apiroute", label: "API Route" },
                  { key: "createdTS", label: "Created Date" },
                  { key: "updatedTS", label: "Updated Date" },
                ];
          
                rowKeys = [{ key: "retried", label: "Retry Status" }];
              } else {
                headerKeys = [
                  { label: "App ID", key: "appID" },
                  { label: "API Type", key: "apiType" },
                  { label: "Status", key: "status" },
                  { key: "apiroute", label: "API Route" },
                  { key: "createdTS", label: "Created Date" },
                  { key: "updatedTS", label: "Updated Date" },
                ];
          
                rowKeys = [{ key: "retried", label: "Retry Status" }];
              }
            }
          
            return {
              headerKeys,
              rowKeys,
            };
          };
          
          const isMobile = useCheckMobileScreen();
          const isTablet = useCheckTabScreen();
          const tableKeys = getTableKeys(isMobile, isTablet, role);

         // logic for handling the retry option in mobile and ipad
          const handleReTry = (record: any) => {
            retryIntegration(record)
          }
          
        return (

            <Layout page="apiintegrations">
                {!(isMobile || isTablet)? <> <div className={(window.innerWidth > 1640) ? 'body-content' : 'listapp-body-content'}>
               <div className='heading flex-spacebetween'>
                        <span className='heading-text-left'>API INTEGRATIONS</span>

                    </div>
                    <AntdTable
                        className="api-integrations"
                        columns={columns}
                        dataSource={data}
                        loading={loading}
                        rowClassName={(record, index) => index % 2 === 0 ? '' : 'antd-table-row-dark'}
                    />
                </div></>: <TableComponent
                    headerList={tableKeys.headerKeys}
                    rowKeys={tableKeys.rowKeys}
                    tableData={data}
                    heading={"API INTEGRATIONS"}
                    uniqueId={"docID"}
                    className={'mobile-table-max'}
                    noAppMessage="NO DATA FOUND"
                    actionButton={false}
                    dynamicActions={(record: any) => {
                        return <Button
                            onClick={() => handleReTry(record)}
                            icon={<ReloadOutlined />}
                            style={{ backgroundColor: 'transparent' }}
                            disabled={record.status !== 'failed' || record.retried}
                        />
                    }
                }
              />}

                <ProgressLoader loading={loading} size='large' />
                <div className='overlay' style={overlay.style}>
                    <div className='overlay-image'>
                        <span className='overlay-text'>{overlayMsg}</span>
                    </div>
                </div>
                <Footer page='apiintegrations'/>
            </Layout>
        )
    }
    return <> {Algolia(APIIntegrations, { config })} </>;
};

export default memo(APIIntegrationsHOC);